export const RELATION_TOOLTIPS: Record<string, string> = {
    parent: "Батьківська ТТ стане архівною і не доступною до продажів та планування, вся її історія, дебеторська заборгованість та інші аналітичні дані будуть привʼязані до нової ТТ",
    independent:
        "Незалежна ТТ означає що обидві точки можуть працювати незалежно одна від одної на одній адресі",
    archived: "Архівна ТТ стане не доступною до продажів та планування",
};
